
// 修改登录状态
const changeIsLogin = (state, isLogin) => {
    state.isLogin = isLogin;
    try {
        localStorage.isLogin = isLogin;
    } catch (error) {
        console.warn(error)
    }
}

// 登录模块
const loginManager = {

    // 获取用户基本信息
    changeUserInfo: (state, userInfo) => {
        var infoData = JSON.stringify(userInfo)
        state.userInfo = JSON.parse(infoData)
        try {
            localStorage.userInfo = infoData
        } catch(error) {
            console.warn(error)
        }
    }
}

// 修改默认地址
const changeGroupAddress = (state, groupAddress) => {
    var address = JSON.stringify(groupAddress)
    state.groupAddress = JSON.parse(address)
    try {
        localStorage.groupAddress = address
    } catch(error) {
        console.warn(error)
    }
}

// 修改结算的地址信息
const changeShoppingCartPreOrderInfoAddress = (state, shoppingCartPreOrderInfo) => {
    var PreOrderInfo = JSON.stringify(shoppingCartPreOrderInfo)
    state.shoppingCartPreOrderInfo.address = JSON.parse(PreOrderInfo)
    try {
        shoppingCartPreOrderInfo = JSON.parse(localStorage.shoppingCartPreOrderInfo)
        shoppingCartPreOrderInfo.address= JSON.parse(PreOrderInfo)
        localStorage.shoppingCartPreOrderInfo = JSON.stringify(shoppingCartPreOrderInfo) 
    } catch(error) {
        console.warn(error)
    }
}

// 使用的平台券和跨店铺券信息
const changeAbacusCouponDTOList = (state, abacusCouponDTOList) => {
    var abacusCouponDTOListInfo = JSON.stringify(abacusCouponDTOList)
    state.abacusCouponDTOList = JSON.parse(abacusCouponDTOListInfo)
    try {
        localStorage.abacusCouponDTOList = abacusCouponDTOListInfo
    } catch(error) {
        console.warn(error)
    }
}

// 使用的店铺券信息
const changeShopCouponMap = (state, shopCouponMap) => {
    console.log(shopCouponMap)
    var shopCouponMapInfo = JSON.stringify(shopCouponMap)
    state.shopCouponMap = JSON.parse(shopCouponMapInfo)
    try {
        localStorage.shopCouponMap = shopCouponMapInfo
    } catch(error) {
        console.warn(error)
    }
}

// 跳转到结算页需要设置到全局的参数
const preOrderManager = {

    // 修改商品信息
    changeGlobalProductsInfo: (state, selectShoppingCartProducts) => {
        var productsInfo = JSON.stringify(selectShoppingCartProducts)
        state.selectShoppingCartProducts = JSON.parse(productsInfo)
        try {
            localStorage.selectShoppingCartProducts = productsInfo
        } catch(error) {
            console.warn(error)
        }
    },

    // 修改优惠券信息
    changeGlobalCouponInfo: (state, shoppingCartCouponData) => {
        var couponInfo = JSON.stringify(shoppingCartCouponData)
        state.shoppingCartCouponData = JSON.parse(couponInfo)
        try {
            localStorage.shoppingCartCouponData = couponInfo
        } catch(error) {
            console.warn(error)
        }
    },

    // 修改订单信息
    changeOrderNumInfo: (state, shoppingCartPreOrderInfo) => {
        var orderNumInfo = JSON.stringify(shoppingCartPreOrderInfo)
        state.shoppingCartPreOrderInfo = JSON.parse(orderNumInfo)
        try {
            localStorage.shoppingCartPreOrderInfo = orderNumInfo
        } catch(error) {
            console.warn(error)
        }
    },

}

// 修改全局记录的邀请人信息
const changeInviteInfo = (state, inviteInfo) => {
    var info = JSON.stringify(inviteInfo)
    state.inviteInfo = JSON.parse(info)
    try {
        sessionStorage.setItem('inviteInfo', info)
    } catch(error) {
        console.warn(error)
    }
}


// 获取CDN参数
const changeCDNFormat = (state, CDNFormat) => {
    var map = JSON.stringify(CDNFormat)
    state.CDNFormat = JSON.parse(map)
    try {
        localStorage.CDNFormat = map
    } catch (error) {
        console.warn(error)
    }
}

//判断当前页面是否可被回退
const updateAppSetting = (state, banBack) => {
    state.banBack = banBack
    try {
        localStorage.banBack = banBack
    } catch (error) {
        console.warn(error)
    }
}

export default{
    changeIsLogin,
    ...loginManager,
    changeGroupAddress,
    changeShoppingCartPreOrderInfoAddress,
    ...preOrderManager,
    changeAbacusCouponDTOList,
    changeShopCouponMap,
    changeInviteInfo,
    changeCDNFormat,
    updateAppSetting
}



// WEBPACK FOOTER //
// ./src/store/mutations.js